import { type AriaAttributes, createContext, useContext } from 'react'

type FieldContextValue = {
  controlId: string
  focusControlOnLabelClick: boolean
  labelId?: string
  descriptionId?: string
  errorId?: string
  registerDescription?: (id: string | undefined) => void
  registerLabel?: (id: string | undefined) => void
  registerError?: (id: string | undefined) => void
}

export const FieldContext = createContext<FieldContextValue | null>(null)

export function useFieldControlProps({
  id,
  'aria-describedby': describedBy,
  'aria-invalid': invalid,
}: Pick<AriaAttributes, 'aria-describedby' | 'aria-invalid'> & { id?: string }) {
  const field = useContext(FieldContext)
  const descriptionIds = [describedBy, field?.descriptionId, field?.errorId]
    .filter(Boolean)
    .join(' ')
    .split(/\s+/)
    .filter(Boolean)

  return {
    id: field?.controlId ?? id,
    'aria-describedby': [...new Set(descriptionIds)].join(' ') || undefined,
    'aria-invalid': field?.errorId ? true : invalid,
  }
}
